export default "__VITE_ASSET__dda2db0d__"